export default __webpack_public_path__ + "static/media/LAS0720.34I-37960_-22232_0.dc209b72.jpg";